import { gql } from '../../../../../hooks'

export const DELETE_RE_SAMPLING = gql`
  mutation AdministrationDeleteSamplingReSampling($id: ID!) {
    aDelete(path: "sampling/resampling", id: $id) {
    }
  }
`

export const LIST_RE_SAMPLING = gql`
  query AdministrationListSamplingReSampling(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "sampling/resampling"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`
